export const getbulkDraggedData = ({ bulkDrag, indexOfSources, indexOfDestination, structure, setBulkDrag }: any) => {
    let finalData: any = [];
    let bulkDragKeys = Object.keys(bulkDrag);
    let bulkDragKeysWithTrueValue: any = [];
    bulkDragKeys.forEach((keys: any) => {
        if (bulkDrag[keys]) {
            bulkDragKeysWithTrueValue.push(keys);
        }
    })
    let cloneStructure = JSON.parse(JSON.stringify(structure));
    let { phases = [] } = cloneStructure;
    let clonePhases = JSON.parse(JSON.stringify(phases));
    let cloneIndexOfDestination = indexOfDestination;
    let indexOfChapterForDestination: any;
    let resetPhases = JSON.parse(JSON.stringify(phases));
    let removePhases: any = [];
    let removeWeeks: any = [];
    let removeChapter: any = [];
    let removeConcept: any = [];
    let isRemovePhases: boolean = false;
    let isRemoveWeeks: boolean = false;
    let isRemoveChapter: boolean = false;
    let isRemoveConcept: boolean = false;

    bulkDragKeysWithTrueValue.forEach((bulkDragKeys: string, indexBulkdrag: number) => {
        let indexOfSources = getArrayFromString(bulkDragKeys);
        let comingFromWhere = indexOfSources[0];
        // console.log(':::::::::::::::::indexes::::::::', comingFromWhere, indexOfSources, indexOfDestination, structure);
        const isSubjectExist = checkSubjectExistOrNot(indexOfSources, cloneIndexOfDestination, structure);
        const { isSubjectExistForConcept, subjectData } = checkSubjectOfConceptExistOrNot(indexOfSources, cloneIndexOfDestination, structure);
        console.log('::::::::ISSubjectExits::::::::::::', subjectData, isSubjectExist, isSubjectExistForConcept);
        indexOfSources = indexOfSources.slice(1);
        if (indexBulkdrag === 0) {
            indexOfDestination = indexOfDestination.slice(1);
        }
        // console.log(':::::::::::NEwindex:::::::::', indexOfDestination);
        let sourceData: any = {};
        let sourceDataForConcept: any = {};
        let sourceDataKey = "";
        let sourceDataIndex = [];
        let removableName = '';
        let indexOfSourceForDestination: any;
        let checkForRemovePhaseDataFromPhase = {
            isPhaseRemovable: false,
            phaseId: ''
        }
        let checkForWeekRemoveFromPhase = {
            isWeekRemove: false,
            weekId: '',
            phaseIndex: 0,
        };
        let chapterRemoveFromPhase = {
            isChapterRemove: false,
            chapterName: '',
            weekIndex: 0,
            phaseIndex: 0,
            subjectIndex: 0,
        };
        let subjectRemovePhase = {
            isChapterRemove: false,
            subjectId: '',
            weekIndex: 0,
            subjectIndex: 0,
        };
        let conceptRemovePhase = {
            isConceptRemove: false,
            conceptName: '',
            subjectIndex: 0,
            chapterIndex: 0,
            conceptIndex: 0,
            weekIndex: 0,
            phaseIndex: 0,
        };
        phases.forEach((phase: any, indexOfPhases: number) => {
            if (indexOfPhases === Number(indexOfSources[0])) {
                // console.log('::::::::::::::::::::::1::::::::::::::::::::::::', indexOfSources);
                const { weeks = [] } = phase;
                weeks.forEach((week: any, indexOfWeeks: number) => {
                    // console.log('::::::::::::::::::::;;2::::::::::::::::::::::::', indexOfWeeks, Number(indexOfSources[1]));
                    if (indexOfWeeks === Number(indexOfSources[1])) {
                        const { subjects = [] } = week;
                        let children: any = [];
                        subjects.forEach((subject: any, indexOfSubject: number) => {
                            // console.log(';::::::::::::::::::::3:::::', indexOfSubject, Number(indexOfSources[2]));
                            if (indexOfSubject === Number(indexOfSources[2])) {
                                sourceData = subject;
                                const { chapters = [] } = subject;
                                chapters.forEach((chapter: any, indexOfChapter: number) => {
                                    if (indexOfChapter === Number(indexOfSources[3])) {
                                        if (comingFromWhere === 'chapter') {
                                            if (isSubjectExist) {
                                                const checkChapterExist = checkChapterExistInSubject(
                                                    indexOfDestination,
                                                    phases,
                                                    chapter
                                                );
                                                console.log(checkChapterExist, ':::::::::::exist::::::::::::::');
                                                if (checkChapterExist && Object.keys(checkChapterExist).length) {
                                                    const getNewChapter = mergeSameChapter(
                                                        indexOfDestination,
                                                        phases,
                                                        chapter
                                                    );
                                                    if (Object.keys(getNewChapter).length) {
                                                        removableName = getNewChapter.name;
                                                        sourceData = { ...sourceData, chapters: [{ ...getNewChapter }] };
                                                    }
                                                } else {
                                                    sourceDataForConcept = { ...sourceData, chapters: [{ ...chapter }] };
                                                    sourceData = { ...sourceData, chapters: [{ ...chapter }] };
                                                    sourceDataKey = '';
                                                    resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                        indexOfSubject
                                                    ]['chapters'] = resetPhases[indexOfPhases]['weeks'][indexOfWeeks][
                                                        'subjects'
                                                    ][indexOfSubject]['chapters'].filter(
                                                        (ele: any) => chapter.name !== ele.name
                                                    );
                                                    chapterRemoveFromPhase.isChapterRemove = true;
                                                    chapterRemoveFromPhase.weekIndex = indexOfWeeks;
                                                    chapterRemoveFromPhase.subjectIndex = indexOfSubject;
                                                    chapterRemoveFromPhase.phaseIndex = indexOfPhases;
                                                    chapterRemoveFromPhase.chapterName = chapter.name;
                                                    removeChapter.push(chapterRemoveFromPhase);
                                                    if (
                                                        !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                        ]['chapters'].length
                                                    ) {
                                                        resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = phases[
                                                            indexOfPhases
                                                        ]['weeks'][indexOfWeeks]['subjects'].filter(
                                                            (ele: any) =>
                                                                ele.name !==
                                                                phases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                                    indexOfSubject
                                                                ].name
                                                        );
                                                        if (
                                                            !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].length
                                                        ) {
                                                            checkForWeekRemoveFromPhase.isWeekRemove = true;
                                                            checkForWeekRemoveFromPhase.weekId = week._id;
                                                            checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
                                                            removeWeeks.push(checkForWeekRemoveFromPhase);
                                                            resetPhases[indexOfPhases]['weeks'] = phases[indexOfPhases][
                                                                'weeks'
                                                            ].filter((ele: any) => ele._id !== week._id);
                                                            if (!resetPhases[indexOfPhases]['weeks'].length) {
                                                                checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
                                                                checkForRemovePhaseDataFromPhase.phaseId = phase._id;
                                                                removePhases.push(checkForRemovePhaseDataFromPhase)
                                                            }
                                                        }
                                                    }
                                                }

                                            }
                                            else {
                                                sourceData = { ...sourceData, chapters: [{ ...chapter }] };
                                                sourceDataForConcept = { ...sourceData, chapters: [{ ...chapter }] };
                                                sourceDataKey = '';
                                                resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                    indexOfSubject
                                                ]['chapters'] = phases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                    indexOfSubject
                                                ]['chapters'].filter(
                                                    (ele: any) =>
                                                        phases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                        ][indexOfSubject]['chapters'][indexOfChapter].name !== ele.name
                                                );
                                                chapterRemoveFromPhase.isChapterRemove = true;
                                                chapterRemoveFromPhase.weekIndex = indexOfWeeks;
                                                chapterRemoveFromPhase.subjectIndex = indexOfSubject;
                                                chapterRemoveFromPhase.phaseIndex = indexOfPhases;
                                                chapterRemoveFromPhase.chapterName = chapter.name;
                                                removeChapter.push(chapterRemoveFromPhase);
                                                if (
                                                    !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                        indexOfSubject
                                                    ]['chapters'].length
                                                ) {
                                                    phases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = phases[
                                                        indexOfPhases
                                                    ]['weeks'][indexOfWeeks]['subjects'].filter(
                                                        (ele: any) =>
                                                            ele.name !==
                                                            phases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                                indexOfSubject
                                                            ].name
                                                    );
                                                    if (
                                                        !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].length
                                                    ) {
                                                        if (
                                                            !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].length
                                                        ) {
                                                            resetPhases[indexOfPhases]['weeks'] = phases[indexOfPhases][
                                                                'weeks'
                                                            ].filter((ele: any) => ele._id !== week._id);
                                                            checkForWeekRemoveFromPhase.isWeekRemove = true;
                                                            checkForWeekRemoveFromPhase.weekId = week._id;
                                                            checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
                                                            removeWeeks.push(checkForWeekRemoveFromPhase);
                                                            if (!resetPhases[indexOfPhases]['weeks'].length) {
                                                                checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
                                                                checkForRemovePhaseDataFromPhase.phaseId = phase._id;
                                                                removePhases.push(checkForRemovePhaseDataFromPhase);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        const { concepts = [] } = chapter;
                                        Number(indexOfSources[4]) >= 0 && concepts.forEach((concept: any, indexOfConcept: number) => {
                                            if (indexOfConcept === Number(indexOfSources[4])) {
                                                console.log("RunTimes", isSubjectExistForConcept);
                                                if (isSubjectExistForConcept && comingFromWhere === 'concept') {
                                                    let checkConcept = checkChapterExistForConcept(
                                                        indexOfDestination,
                                                        clonePhases,
                                                        chapter
                                                    );
                                                    console.log('::::::::::checkConcept:::::::::::', checkConcept);
                                                    if (!checkConcept) {
                                                        subjectData['chapters'][indexOfChapter]['concepts'] = [
                                                            { ...concept },
                                                        ];
                                                        indexOfSourceForDestination = indexOfChapter;
                                                        sourceData = JSON.parse(JSON.stringify(subjectData));
                                                        indexOfChapterForDestination = indexOfChapter;

                                                        sourceDataKey = 'concepts';
                                                    } else {
                                                        checkConcept.concepts.push(concept);
                                                        subjectData['chapters'][indexOfChapter] = { ...checkConcept };
                                                        sourceData = JSON.parse(JSON.stringify(subjectData));
                                                        indexOfSourceForDestination = indexOfChapter;
                                                        sourceDataKey = 'concepts';
                                                    }
                                                    // for deleting data of concept
                                                    if (
                                                        resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                        ]['chapters'][indexOfChapter]['concepts'].length === 1
                                                    ) {
                                                        chapterRemoveFromPhase.isChapterRemove = true;
                                                        chapterRemoveFromPhase.weekIndex = indexOfWeeks;
                                                        chapterRemoveFromPhase.subjectIndex = indexOfSubject;
                                                        chapterRemoveFromPhase.phaseIndex = indexOfPhases;
                                                        chapterRemoveFromPhase.chapterName = chapter.name;
                                                        removeChapter.push(chapterRemoveFromPhase);
                                                        resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                        ]['chapters'] = resetPhases[indexOfPhases]['weeks'][indexOfWeeks][
                                                            'subjects'
                                                        ][indexOfSubject]['chapters'].filter(
                                                            (ele: any) => ele.name !== chapter.name
                                                        );
                                                        if (
                                                            !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                            ]['chapters']
                                                        ) {
                                                            resetPhases[indexOfPhases]['weeks'][indexOfWeeks][
                                                                'subjects'
                                                            ] = resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].filter(
                                                                (ele: any) =>
                                                                    resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                                        indexOfSubject
                                                                    ].id !== ele.id
                                                            );
                                                            if (
                                                                !resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects']
                                                                    .length
                                                            ) {
                                                                checkForWeekRemoveFromPhase.isWeekRemove = true;
                                                                checkForWeekRemoveFromPhase.weekId = week._id;
                                                                checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
                                                                removeWeeks.push(checkForWeekRemoveFromPhase);
                                                                resetPhases[indexOfPhases]['weeks'] = resetPhases[indexOfPhases][
                                                                    'weeks'
                                                                ].filter((ele: any) => ele._id !== week._id);
                                                                if (!resetPhases[indexOfPhases]['weeks'].length) {
                                                                    checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
                                                                    checkForRemovePhaseDataFromPhase.phaseId = phase._id;
                                                                    removePhases.push(checkForRemovePhaseDataFromPhase);
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        conceptRemovePhase.isConceptRemove = true;
                                                        conceptRemovePhase.subjectIndex = indexOfSubject;
                                                        conceptRemovePhase.conceptIndex = indexOfConcept;
                                                        conceptRemovePhase.chapterIndex = indexOfChapter;
                                                        conceptRemovePhase.weekIndex = indexOfWeeks;
                                                        conceptRemovePhase.phaseIndex = indexOfPhases;
                                                        conceptRemovePhase.conceptName = concept.name;
                                                        removeConcept.push(conceptRemovePhase);
                                                        resetPhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'][
                                                            indexOfSubject
                                                        ]['chapters'][indexOfChapter]['concepts'] = resetPhases[indexOfPhases][
                                                            'weeks'
                                                        ][indexOfWeeks]['subjects'][indexOfSubject]['chapters'][
                                                            indexOfChapter
                                                        ]['concepts'].filter((ele: any) => {
                                                            if (ele.name !== concept.name) {
                                                                return ele;
                                                            }
                                                        });
                                                    }
                                                } else {
                                                    // this can couse trouble remove after debugging
                                                    console.log('RunTimes', isSubjectExist);
                                                    if (isSubjectExist) {
                                                        sourceData = '';
                                                        sourceDataKey = '';
                                                    } else {
                                                        let newSourceData = JSON.parse(JSON.stringify(sourceDataForConcept));
                                                        newSourceData['chapters'][indexOfChapter]['concepts'] = [
                                                            { ...concept },
                                                        ];
                                                        sourceData = JSON.parse(JSON.stringify(newSourceData));
                                                        sourceDataKey = '';
                                                    }
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        phases.forEach((phase: any, indexOfPhases: number) => {
            console.log('::::::::::::Insource::::::::::::::', sourceData);
            if (indexOfPhases === Number(indexOfDestination[0])) {
                const { weeks = [] } = phase;
                weeks.forEach((week: any, indexOfWeeks: number) => {
                    if (indexOfWeeks === Number(indexOfDestination[1])) {
                        const { subjects = [] } = week;
                        let children: any = [];
                        subjects.forEach((ele: any) =>
                            ele.chapters.forEach((element: any) => children.push(element))
                        );
                        // clonePhases = JSON.parse(JSON.stringify(phases));
                        console.log(':::::::::::::comingForm::::::', comingFromWhere, isSubjectExist, sourceData);
                        if (comingFromWhere === 'chapter') {
                            if (isSubjectExist) {
                                let cloneSubjects: any = {};

                                clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].forEach((subject: any) => {
                                    if (subject.id === sourceData.id) {
                                        cloneSubjects = { ...JSON.parse(JSON.stringify(subject)) };
                                    }
                                });
                                console.log('::::::::::cloneSubjects:::::::::---', cloneSubjects);
                                cloneSubjects['chapters'] = cloneSubjects['chapters'].filter(
                                    (ele: any) => ele.name !== removableName
                                );

                                cloneSubjects['chapters'] = JSON.parse(JSON.stringify([
                                    ...JSON.parse(JSON.stringify(cloneSubjects['chapters'])),
                                    ...JSON.parse(JSON.stringify(sourceData['chapters'])),
                                ]))

                                console.log('::::::::::::::cloneSubjects:::::::::::::', cloneSubjects, sourceData, removableName);
                                clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = clonePhases[
                                    indexOfPhases
                                ]['weeks'][indexOfWeeks]['subjects'].filter((ele: any) => ele.id !== sourceData.id);

                                clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(cloneSubjects);
                            } else {
                                clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(sourceData);
                            }
                        }
                        if (comingFromWhere === 'concept') {
                            let conceptData: any = [];
                            let chapterData: any = [];
                            clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].map(
                                (ele: any) =>
                                    ele.id === sourceData.id &&
                                    ele.chapters.forEach((ele: any) => {
                                        chapterData.push(ele);
                                        sourceData['chapters'][0].name === ele.name &&
                                            ele.concepts.forEach((ele: any) => conceptData.push(ele));
                                    })
                            );
                            console.log(
                                ':::::::::::::chapters::::::::::::::::data:::::',
                                chapterData,
                                sourceData,
                                indexOfSourceForDestination
                            );
                            chapterData = chapterData.filter(
                                (ele: any) => ele.name !== sourceData['chapters'][indexOfSourceForDestination].name
                            );
                            chapterData &&
                                chapterData.length &&
                                (sourceData['chapters'] = [
                                    { ...sourceData['chapters'][indexOfSourceForDestination] },
                                    ...JSON.parse(JSON.stringify(chapterData)),
                                ]);
                            clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = clonePhases[
                                indexOfPhases
                            ]['weeks'][indexOfWeeks]['subjects'].filter(
                                (ele: any) => ele.name !== sourceData.name
                            );
                            clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(sourceData);
                        }
                    }
                });
            }
        });

        if (checkForRemovePhaseDataFromPhase.isPhaseRemovable) {
            isRemovePhases = true;
            isRemoveWeeks = false;
            isRemoveChapter = false;
            isRemoveConcept = false;
        }
        if (
            !checkForRemovePhaseDataFromPhase.isPhaseRemovable &&
            checkForWeekRemoveFromPhase.isWeekRemove
        ) {
            isRemoveWeeks = true;
            isRemoveChapter = false;
            isRemoveConcept = false;
            isRemovePhases = false;
        }
        if (
            !checkForRemovePhaseDataFromPhase.isPhaseRemovable &&
            !checkForWeekRemoveFromPhase.isWeekRemove &&
            chapterRemoveFromPhase.isChapterRemove
        ) {
            isRemoveChapter = true;
            isRemoveWeeks = false;
            isRemoveConcept = false;
            isRemovePhases = false;
        }
        if (
            !checkForRemovePhaseDataFromPhase.isPhaseRemovable &&
            !checkForWeekRemoveFromPhase.isWeekRemove &&
            !chapterRemoveFromPhase.isChapterRemove &&
            conceptRemovePhase.isConceptRemove
        ) {
            isRemoveConcept = true;
            isRemoveWeeks = false;
            isRemoveChapter = false;
            isRemovePhases = false;
        }

    });
    // console.log(finalData, ':::::::::finalData::::::::;');
    // console.log('::::::::ClonePhases::::::::::', clonePhases);
    let newBulkData = JSON.parse(JSON.stringify(clonePhases))
    console.log('::::::::::::newBulkData::::', newBulkData, { isRemoveChapter, isRemoveWeeks, isRemovePhases }, removePhases);
    isRemovePhases && removePhases && removePhases.length && removePhases.forEach((checkForRemovePhaseDataFromPhase: any) => {
        newBulkData = newBulkData.filter(
            (ele: any) => ele._id !== checkForRemovePhaseDataFromPhase.phaseId
        );
    })
    isRemoveWeeks && removeWeeks && removeWeeks.length && removeWeeks.forEach((checkForWeekRemoveFromPhase: any) => {
        console.log(':::::::::::;clonePhases:::::::::::', clonePhases);
        newBulkData[checkForWeekRemoveFromPhase.phaseIndex]['weeks'] = newBulkData[
            checkForWeekRemoveFromPhase.phaseIndex
        ]['weeks'].filter((ele: any) => ele._id !== checkForWeekRemoveFromPhase.weekId);
    })
    isRemoveChapter && removeChapter && removeChapter.length && removeChapter.forEach((chapterRemoveFromPhase: any) => {
        const { chapterName, phaseIndex, subjectIndex, weekIndex } = chapterRemoveFromPhase;
        newBulkData[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex][
            'chapters'
        ] = newBulkData[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'].filter(
            (ele: any) => ele.name !== chapterName
        );
    })
    isRemoveConcept && removeConcept && removeConcept.length && removeConcept.forEach((conceptRemovePhase: any) => {
        const {
            subjectIndex,
            conceptIndex,
            conceptName,
            phaseIndex,
            chapterIndex,
            weekIndex,
        } = conceptRemovePhase;
        newBulkData[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'][
            chapterIndex
        ]['concepts'] = newBulkData[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex][
            'chapters'
        ][chapterIndex]['concepts'].filter((ele: any) => ele.name !== conceptName);
    });
    phases = JSON.parse(JSON.stringify(newBulkData));
    setBulkDrag({
        bulkDrag: {}
    })
    return { phases: JSON.parse(JSON.stringify(phases)) };
}


const getArrayFromString = (ids: string) => {
    let totalRequiredIndex = 6;
    let arrayOfIndex = ids.split("-");
    for (let i = arrayOfIndex.length; i < totalRequiredIndex; i++) {
        arrayOfIndex.push("-1");
    }
    return arrayOfIndex;
};


const checkSubjectExistOrNot = (indexOfSources: any, indexOfDestination: any, structure: any) => {
    let cloneStructure = JSON.parse(JSON.stringify(structure));
    const { phases = [] } = cloneStructure;
    let phaseIndex = Number(indexOfSources[1]);
    let weekIndex = Number(indexOfSources[2]);
    let subjectIndex = Number(indexOfSources[3]);
    // console.log(indexOfSources, ':::::::::sources:::::::::');

    let indexOfSourceSubjectData: any = getSubjectData({ phases, phaseIndex, weekIndex, subjectIndex });
    console.log(indexOfDestination, '::::::::::::sourceSubjectData::::::::::');
    phaseIndex = Number(indexOfDestination[1]);
    weekIndex = Number(indexOfDestination[2]);
    subjectIndex = Number(indexOfDestination[3]);
    let subjectData = indexOfSourceSubjectData;
    let isSubjectExist = checkDestinationIfSubjectExistOrNot({ phases, phaseIndex, weekIndex, subjectIndex, subjectData });
    return isSubjectExist;
}

const getSubjectData = ({ phases, phaseIndex, weekIndex, subjectIndex }: any) => {
    let subjectData = {};
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === phaseIndex) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === weekIndex) {
                    const { subjects = [] } = week;
                    subjects.forEach((subject: any, indexOfSubject: number) => {
                        // console.log("::::::::Subject:::::::::::", indexOfSubject, subjectIndex);
                        if (indexOfSubject === subjectIndex) {
                            const { chapters = [] } = subject;
                            subjectData = subject;
                        }
                    });
                }
            });
        }
    });

    return subjectData;
}

const checkDestinationIfSubjectExistOrNot = ({ phases, phaseIndex, weekIndex, subjectIndex, subjectData }: any) => {
    let checkSubjectExists = false;
    console.log(phases, phaseIndex, weekIndex, subjectData);
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === phaseIndex) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === weekIndex) {
                    const { subjects = [] } = week;
                    const subjectNames = subjects.map((ele: any) => ele.id)
                    console.log(':::::::::::::SubjectData:::::::::::::', subjectNames, subjectData.id);
                    checkSubjectExists = subjectNames.includes(subjectData.id)
                }
            });
        }
    });
    return checkSubjectExists;
}
const checkSubjectOfConceptExistOrNot = (indexOfSources: any, indexOfDestination: any, structure: any) => {
    let cloneStructure = JSON.parse(JSON.stringify(structure));
    const { phases = [] } = cloneStructure;
    let phaseIndex = Number(indexOfSources[1]);
    let weekIndex = Number(indexOfSources[2]);
    let subjectIndex = Number(indexOfSources[3]);
    let chapterIndex = Number(indexOfSources[4]);
    let conceptIndex = Number(indexOfSources[5]);

    let indexOfSourceSubjectData: any = getSubjectDataAccordingToConcept({ phases, phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex });
    console.log(indexOfSourceSubjectData, indexOfDestination
        , ';:::::::::sourceSubjectData::::::::::::');
    phaseIndex = Number(indexOfDestination[1]);
    weekIndex = Number(indexOfDestination[2]);
    subjectIndex = Number(indexOfDestination[3]);
    let subjectData = indexOfSourceSubjectData;
    let isSubjectExistForConcept = checkDestinationIfSubjectOfConceptExistOrNot({ phases, phaseIndex, weekIndex, subjectIndex, subjectData });
    console.log('::::::isSUbjectExistForConcept::::', isSubjectExistForConcept);
    return { isSubjectExistForConcept, subjectData };
}

const getSubjectDataAccordingToConcept = ({ phases, phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex }: any) => {
    let subjectData = {};
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === phaseIndex) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === weekIndex) {
                    const { subjects = [] } = week;
                    subjects.forEach((subject: any, indexOfSubject: number) => {
                        if (indexOfSubject === subjectIndex) {
                            const { chapters = [] } = subject;
                            chapters.forEach((chapter: any, indexOfChapter: number) => {
                                if (chapterIndex === indexOfChapter) {
                                    const { concepts = [] } = chapter;
                                    concepts.forEach((concept: any, indexOfConcept: number) => {
                                        if (conceptIndex === indexOfConcept) {
                                            subjectData = subject;
                                        }
                                    });
                                }
                            })
                        }
                    });
                }
            });
        }
    });

    return subjectData;

}
const checkDestinationIfSubjectOfConceptExistOrNot = ({ phases, phaseIndex, weekIndex, subjectIndex, subjectData }: any) => {
    let checkSubjectExists = false;
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === phaseIndex) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === weekIndex) {
                    const { subjects = [] } = week;
                    const subjectNames = subjects.map((ele: any) => ele.id)
                    console.log(subjectNames, subjectData.id, '::::::::subjectId:::::::::');
                    checkSubjectExists = subjectNames.includes(subjectData.id);
                }
            });
        }
    });
    return checkSubjectExists;

}

const checkChapterExistForConcept = (indexOfDestination: any, phases: any, chapter: any) => {
    let getConcept: any = {};
    let allChapters: any = [];
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === Number(indexOfDestination[0])) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === Number(indexOfDestination[1])) {
                    const { subjects = [] } = week;
                    subjects.forEach((ele: any) => ele.chapters.forEach((ele: any) => allChapters.push(ele)));
                }
            });
        }
    });
    getConcept = allChapters.find((ele: any) => ele.name === chapter.name);
    return getConcept;
};
const checkChapterExistInSubject = (indexOfDestination: any, phases: any, chapter: any) => {
    let getConcept = {};
    let allChapters: any = [];
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === Number(indexOfDestination[0])) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === Number(indexOfDestination[1])) {
                    const { subjects = [] } = week;
                    subjects.forEach((ele: any) => ele.chapters.forEach((ele: any) => allChapters.push(ele)));
                }
            });
        }
    });
    getConcept = allChapters.find((ele: any) => ele.name === chapter.name);
    return getConcept;
};

const mergeSameChapter = (indexOfDestination: any, phases: any, chapter: any) => {
    let getConcept: any = {};
    let allChapters: any = [];
    phases.forEach((phase: any, indexOfPhase: number) => {
        if (indexOfPhase === Number(indexOfDestination[0])) {
            const { weeks = [] } = phase;
            weeks.forEach((week: any, indexOfWeek: number) => {
                if (indexOfWeek === Number(indexOfDestination[1])) {
                    const { subjects = [] } = week;
                    subjects.forEach((ele: any) => ele.chapters.forEach((ele: any) => allChapters.push(ele)));
                }
            });
        }
    });
    getConcept = allChapters.find((ele: any) => ele.name === chapter.name);
    if (getConcept && Object.keys(getConcept).length) {
        chapter.concepts.forEach((ele: any) => {
            getConcept.concepts.push(ele);
        });
        return getConcept;
    }
    return getConcept;
};